/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHouseIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-house"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.45 20.8Q5.63 20.8 5.04 20.21Q4.45 19.63 4.45 18.8L4.45 11.4L2.85 12.65Q2.42 13 1.88 12.93Q1.32 12.85 0.97 12.4Q0.65 11.97 0.72 11.44Q0.8 10.9 1.23 10.55L10.38 3.45Q10.72 3.17 11.15 3.04Q11.57 2.9 12 2.9Q12.43 2.9 12.85 3.04Q13.28 3.17 13.63 3.45L15.88 5.2L15.88 5.03Q15.88 4.28 16.41 3.74Q16.95 3.2 17.7 3.2Q18.45 3.2 18.99 3.74Q19.52 4.28 19.52 5.03L19.52 8.03L22.77 10.55Q23.2 10.9 23.26 11.44Q23.32 11.97 23 12.4Q22.65 12.85 22.1 12.93Q21.55 13 21.13 12.65L19.52 11.4L19.52 18.8Q19.52 19.63 18.95 20.21Q18.38 20.8 17.55 20.8L15.75 20.8Q14.93 20.8 14.34 20.21Q13.75 19.63 13.75 18.8L13.75 16.02Q13.75 15.3 13.24 14.8Q12.72 14.3 12 14.3L12 14.3Q11.28 14.3 10.76 14.81Q10.25 15.32 10.25 16.05L10.25 18.8Q10.25 19.63 9.68 20.21Q9.1 20.8 8.28 20.8ZM9.8 10.13L14.2 10.13Q14.2 9.25 13.54 8.68Q12.88 8.1 12 8.1Q11.13 8.1 10.46 8.68Q9.8 9.25 9.8 10.13Z" fill={color} />
    </svg>
  );
}
